<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
  <div class="max-w-md w-full mx-4 p-6 rounded-xl border border-red-500/40 bg-[var(--nexus-surface)] shadow-2xl">
    <h2 class="text-red-400 font-mono text-sm uppercase tracking-wider mb-2">Unexpected Error</h2>
    <p class="text-sm text-[var(--nexus-text-muted)] mb-4 font-mono break-all">{{ message() }}</p>
    <p class="text-xs text-[var(--nexus-text-dim)] mb-4">Reload the page if the problem persists.</p>
    <div class="flex gap-2 justify-end">
      <button class="nx-btn-ghost nx-btn-sm" (click)="dismissed.emit()">Dismiss</button>
      <button class="nx-btn-danger nx-btn-sm" (click)="reload()">Reload</button>
    </div>
  </div>
</div>
